import { Observable } from 'rxjs/Rx';
import { LocalShoppingItemsData } from './local-shopping-items-data';
import { RecipeData } from '../../recipes/providers/recipe-data';
import { Injectable } from '@angular/core';
import { FireBaseObjectNames } from '../../../core/codes';
import { AngularFireDatabaseWrapper } from '../../../providers/angularfire-wrapper';
@Injectable()
export class GuestShoppingItemsData {
    constructor(public afw: AngularFireDatabaseWrapper,
        public recipeData: RecipeData,
        public localShoppingItemsData: LocalShoppingItemsData

    ) {

    }
    public cleanData() {
        console.log('----------------------cleanData Shopping list');
        let data = [];
        return this.localShoppingItemsData.set('guest',data);
    }
    public get(userId) {
        console.log('get from local');
        return Observable.fromPromise(this.localShoppingItemsData.search(userId ? userId : "guest")).map((shoppingItems: any) => {
            return shoppingItems;
        })
    }
    public add(userId, item) {
        return this.localShoppingItemsData.add(userId ? userId : "guest", item.refId, item);
        // return new Promise((resolve, reject) => {
        //     let strgRef = LocalStorageCodes.SHOPPING_ITEMS + '/' + userId,
        //         ref = this.afw.list(strgRef);
        //     var key = ref.push(item).key;
        //     item['$key'] = key;
        //     this.recipeData.updateTimeStampModified(strgRef);
        //     console.log(item);
        //     return resolve(item);
        // });
    }
    public remove(userId, itemKey) {
        return this.localShoppingItemsData.remove(userId ? userId : "guest", itemKey);
    }
    public updateIsGotItem(userId, item, isGot) {
        return new Promise((resolve, reject) => {
            let strgRef = FireBaseObjectNames.SHOPPING_ITEMS + '/' + userId + '/' + item.$key,
                ref = this.afw.object(strgRef);
            ref.update({ isGot: isGot });
            this.recipeData.updateTimeStampModified(strgRef);
            return resolve(true);
        });
    }

}


// WEBPACK FOOTER //
// ./src/modules/account/providers/guest-shopping-items-data.ts